import GroupTag from './GroupTag';
export default GroupTag;
